import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react';
import { cn } from '../../utils/helper';

function CommonPopover({
  label,
  children,
  contentClassName,
  className,
  containerClassName,
  anchor = 'bottom'
}) {
  return (
    <Popover className="relative">
      <PopoverButton
        className={`${className} inline-flex items-center justify-center rounded-3xl border px-2 py-1 font-medium hover:shoorah-primary focus:outline-none `}
      >
        {label}
      </PopoverButton>
      <PopoverPanel
        anchor={anchor}
        className={`absolute z-10 p-2 rounded-md dark:bg-shoorah-darkBgColor dark:text-white bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none ${contentClassName}`}
      >
        {children}
      </PopoverPanel>
    </Popover>
  );
}

export default CommonPopover;
